(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7440],{

/***/ 7314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Minus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { d: "M5 12h14", key: "1ays0h" }]];
const Minus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("minus", __iconNode);


//# sourceMappingURL=minus.js.map


/***/ }),

/***/ 31012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Plus; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
];
const Plus = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("plus", __iconNode);


//# sourceMappingURL=plus.js.map


/***/ }),

/***/ 43970:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/integrations",
      function () {
        return __webpack_require__(39643);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8129:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _v3_Buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56475);


const CTASection = (param)=>{
    let { btnText , btnUrl  } = param;
    return /*#__PURE__*/ _jsxs("section", {
        className: "bg-[#f4f2f0] text-black py-16 md:px-10 px-4 xl:px-20 text-center",
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: "text-4xl md:text-7xl font-semibold leading-snug md:mt-20 mt-4 max-w-screen-xl mx-auto mb-16 tracking-tight",
                children: "Transform service with BoloSign's AI agent platform"
            }),
            /*#__PURE__*/ _jsx(CLMButtonPrimary, {
                buttonText: btnText,
                buttonUrl: btnUrl
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (CTASection)));


/***/ }),

/***/ 74791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7314);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31012);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function FaqItem(param) {
    let { question , answer , isOpen , onToggle  } = param;
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: onToggle,
        className: "px-8 py-7 transition-all duration-300",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "flex justify-between items-center w-full text-left gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-[20px] leading-[26px] font-semibold",
                        children: question
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-purple-600 text-xl border-2 border-purple-600 rounded-full p-1",
                        children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            size: 20
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentRef,
                style: {
                    maxHeight: "".concat(height, "px"),
                    overflow: "hidden",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                    opacity: isOpen ? 1 : 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: answer
                    },
                    className: "mt-6 text-gray-700 text-[18px] leading-[26px] font-medium"
                })
            })
        ]
    });
}
function FaqList(param) {
    let { faqs  } = param;
    const [openIndex, setOpenIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: faqs.map((faq, index)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " bg-white rounded-2xl border border-surface-dark mt-4 text-left w-full mx-auto ".concat(openIndex === index ? "" : "hover:bg-surface-dark", " transition-all  duration-300"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqItem, {
                    question: faq === null || faq === void 0 ? void 0 : faq.question,
                    answer: faq === null || faq === void 0 ? void 0 : faq.answer,
                    isOpen: openIndex === index,
                    onToggle: ()=>setOpenIndex(openIndex === index ? null : index)
                }, index)
            }, index);
        })
    });
}
const FAQ2 = (param)=>{
    let { faqData , heading , description  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "md:w-[920px] max-w-full mx-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-4xl md:text-5xl font-semibold leading-snug mb-8",
                children: heading
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-[18px] leading-[22px] font-medium md:w-[80%] mx-auto w-full mt-2 mb-12",
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqList, {
                faqs: faqData
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQ2);


/***/ }),

/***/ 7434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export companyLogos */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_fast_marquee__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97005);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _CaseStudyHoverCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23660);
/* harmony import */ var _case_studies_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15991);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43138);









const companyLogos = [
    {
        url: "9.png",
        name: "ABC Eyecare",
        haveCaseStudy: true,
        companyKey: "abc-eyecare".toLowerCase()
    },
    {
        url: "5.png",
        name: "Angelfire",
        haveCaseStudy: true,
        companyKey: "angel-fire".toLowerCase()
    },
    {
        url: "10.png",
        name: "G & H Transport",
        haveCaseStudy: true,
        companyKey: "g-h-transport".toLowerCase()
    },
    {
        url: "4.png",
        name: "Beaver",
        haveCaseStudy: true,
        companyKey: "beaver".toLowerCase()
    },
    {
        url: "2.png",
        name: "Shine Above",
        haveCaseStudy: true,
        companyKey: "shine-above".toLowerCase()
    },
    {
        url: "1.png",
        name: "Harry Corry",
        haveCaseStudy: true,
        companyKey: "harry-corry-ltd".toLowerCase()
    },
    {
        url: "6.png",
        name: "Rethink",
        haveCaseStudy: true,
        companyKey: "rethink".toLowerCase()
    },
    {
        url: "12.png",
        name: "Overstock Furniture",
        haveCaseStudy: true,
        companyKey: "overstock-furniture".toLowerCase()
    },
    {
        url: "11.png",
        name: "Lifestyle Design",
        haveCaseStudy: true,
        companyKey: "lifestyle-design".toLowerCase()
    },
    {
        url: "7.png",
        name: "Mancosa",
        haveCaseStudy: true,
        companyKey: "mancosa".toLowerCase()
    },
    {
        url: "3.png",
        name: "Aging Comfort",
        haveCaseStudy: true,
        companyKey: "aging-comfort".toLowerCase()
    },
    {
        url: "8.png",
        name: "Benavest",
        haveCaseStudy: true,
        companyKey: "benavest".toLowerCase()
    }
];
const generateTestimonials = (companyKey)=>{
    let caseStudy = caseStudies.find((caseStudy)=>caseStudy.key === companyKey);
    if (!caseStudy) {
        caseStudy = caseStudies.find((caseStudy)=>caseStudy.key === "harry-corry-ltd");
    }
    const testimonial = {
        logo: caseStudy.companyLogo,
        company: caseStudy.name,
        quote: caseStudy.customerInsight.insight,
        name: caseStudy.customerInsight.by,
        title: caseStudy.customerInsight.authorPosition,
        avatar: caseStudy.customerInsight.image
    };
    return testimonial;
};
const AnimatedLogos = (param)=>{
    let { isInvert =false  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const [hoveredIdx, setHoveredIdx] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null);
    const [hoveredKey, setHoveredKey] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null);
    const [hoverPosition, setHoverPosition] = react__WEBPACK_IMPORTED_MODULE_1__.useState({
        x: 0,
        y: 0
    });
    const handleLogoClick = (companyKey)=>{
        router.push("/signature/case-studies/".concat(companyKey));
    };
    const handleMouseEnter = (param)=>{
        let { idx , companyKey , event  } = param;
        const rect = event.currentTarget.getBoundingClientRect();
        const marqueeRect = event.currentTarget.closest(".marquee-container").getBoundingClientRect();
        // Calculate position relative to the marquee container
        const x = rect.left - marqueeRect.left + rect.width / 2;
        const y = rect.top - marqueeRect.top;
        let formattedY = y - 280;
        if (companyKey === "angelfire") {
            formattedY = y - 320;
        } else if (companyKey === "mancosa") {
            formattedY = y - 380;
        } else if (companyKey === "beaver") {
            formattedY = y - 320;
        }
        setHoverPosition({
            x,
            y: formattedY
        });
        setHoveredIdx(idx);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "w-full overflow-visible relative h-fit ",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "marquee-container relative overflow-hidden",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_fast_marquee__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                gradient: false,
                speed: 40,
                className: " overflow-hidden p-2 rounded-md",
                pauseOnHover: true,
                children: companyLogos.map((logo, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mx-8 flex flex-col items-center group cursor-pointer relative h-[144px]",
                        onClick: ()=>handleLogoClick(logo.companyKey),
                        onMouseEnter: (e)=>handleMouseEnter({
                                idx,
                                companyKey: logo.companyKey,
                                event: e
                            }),
                        onMouseLeave: ()=>setHoveredIdx(null),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative h-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/company/").concat(logo.url),
                                alt: logo.name,
                                className: "object-contain transition duration-300 group-hover:filter ".concat(isInvert ? "invert" : ""),
                                width: 120,
                                height: 120,
                                loading: "lazy"
                            })
                        })
                    }, idx))
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AnimatedLogos);


/***/ }),

/***/ 23660:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);




const CaseStudyHoverCard = (param)=>{
    let { logo , company , quote , name , title , avatar , className =""  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "bg-white shadow-lg hover:shadow-xl rounded-2xl p-5 w-80 max-w-sm border border-gray-50 z-50 transition-all duration-300 ".concat(styles.fadeScaleIn, " ").concat(className),
        style: {
            pointerEvents: "auto"
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-3 mb-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "relative w-10 h-10 rounded-lg overflow-hidden bg-gray-50 shrink-0",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: logo,
                            alt: company,
                            fill: true,
                            className: "object-contain"
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "font-semibold text-gray-900 text-base",
                        children: company
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("blockquote", {
                className: "text-gray-600 text-sm mb-4 leading-relaxed line-clamp-3 italic",
                children: quote
            }),
            /*#__PURE__*/ _jsx("hr", {
                className: "my-3 border-gray-100"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-3 mt-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "relative w-8 h-8 rounded-full overflow-hidden bg-gray-50 ring-2 ring-gray-100 shrink-0",
                        children: /*#__PURE__*/ _jsx(Image, {
                            src: avatar || "https://avatar.iran.liara.run/public/boy?username=".concat(name),
                            alt: name,
                            fill: true,
                            className: "object-cover"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "font-semibold text-gray-900 text-xs",
                                children: name
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "text-gray-500 text-[10px] mt-0.5",
                                children: title
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (CaseStudyHoverCard)));


/***/ }),

/***/ 39643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_CLM_CLMFooter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30518);
/* harmony import */ var components_CLM_CLMNavbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25700);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56475);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var components_customers_AnimatedLogos__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7434);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43138);
/* harmony import */ var components_CLM_FAQ2__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74791);
/* harmony import */ var components_CLM_CTASection__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8129);













const companyLogos = [
    {
        url: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/case-studies/angelfire.png"),
        name: "Angelfire",
        haveCaseStudy: true,
        companyKey: "angel-fire".toLowerCase()
    },
    {
        url: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/case-studies/transport.png"),
        name: "G & H Transport",
        haveCaseStudy: true,
        companyKey: "g-h-transport".toLowerCase()
    },
    {
        url: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/case-studies/beaver.png"),
        name: "Beaver",
        haveCaseStudy: true,
        companyKey: "beaver".toLowerCase()
    },
    {
        url: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/case-studies/shine-above.png"),
        name: "Shine Above",
        haveCaseStudy: true,
        companyKey: "shine-above".toLowerCase()
    },
    {
        url: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/case-studies/harry-corry.png"),
        name: "Harry Corry",
        haveCaseStudy: true,
        companyKey: "harry-corry-ltd".toLowerCase()
    },
    {
        url: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/case-studies/rethink.png"),
        name: "Rethink",
        haveCaseStudy: true,
        companyKey: "rethink".toLowerCase()
    },
    {
        url: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/case-studies/mancosa.png"),
        name: "Mancosa",
        haveCaseStudy: true,
        companyKey: "mancosa".toLowerCase()
    },
    {
        url: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/case-studies/aging-comfort.png"),
        name: "Aging Comfort",
        haveCaseStudy: true,
        companyKey: "aging-comfort".toLowerCase()
    }
];
function Dropdown() {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const dropdownList = [
        "All Categories",
        "CRM",
        "Clouad Storage",
        "Collaboration",
        "Email",
        "E-signing",
        "SSO",
        "Ticketing",
        "Systems",
        "Others"
    ];
    // Handle click outside
    useEffect(()=>{
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative inline-block text-left w-full md:w-auto",
        ref: dropdownRef,
        onClick: ()=>setIsOpen(!isOpen),
        children: [
            /*#__PURE__*/ _jsxs("button", {
                type: "button",
                // if isOpen false then rounded-b-xl
                className: "text-gray-500 border rounded-t-xl whitespace-nowrap font-medium  px-5 py-2.5 inline-flex items-center w-full ".concat(isOpen ? "" : "rounded-b-xl"),
                children: [
                    "All Categories",
                    /*#__PURE__*/ _jsx(ChevronDown, {
                        className: "w-6 h-6 ml-auto md:ml-2"
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ _jsx("div", {
                className: "absolute z-10 w-full md:w-44 bg-white rounded-lg shadow-sm divide-y divide-gray-100 dark:bg-gray-700",
                children: /*#__PURE__*/ _jsx("ul", {
                    className: " border rounded-b-xl",
                    children: dropdownList.map((item, index)=>/*#__PURE__*/ _jsx("li", {
                            className: "px-4 py-2 text-gray-500 rounded hover:bg-gray-100",
                            children: item
                        }, index))
                })
            })
        ]
    });
}
const Integrations = ()=>{
    const automation = [
        {
            image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/v2/clm/clm/integrations-zapier-2.webp"),
            heading: "Zapier",
            desc: "Connect BoloSign with 6000+ apps to automate your workflows and save time."
        },
        {
            image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/v2/clm/clm/integrations-pabbly.webp"),
            heading: "Pabbly",
            desc: "Connect BoloSign with Pabbly and do more with your forms and submissions."
        },
        {
            image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/v2/clm/clm/integrations-make.webp"),
            heading: "Make",
            desc: "Automate your work. Build something new. Trusted by thousands of fast-scaling organizations around the globe."
        }
    ];
    const salesAndCrm = [
        {
            image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/v2/clm/clm/integrations-pipedrive.webp"),
            heading: "Pipedrive",
            desc: "Pipedrive is a CRM-replacing sales pipeline management tool."
        },
        {
            image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/v2/clm/clm/integrations-crm.webp"),
            heading: "CRM",
            desc: "A CRM-replacing sales pipeline management tool."
        },
        {
            image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/v2/clm/clm/integrations-hubspot.webp"),
            heading: "HubSpot",
            desc: "HubSpot is the flexible, intuitive CRM system for your small business."
        },
        {
            image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/v2/clm/clm/integrations-airtable.webp"),
            heading: "AirTable",
            desc: "AirTable is the flexible, intuitive CRM system for your small business."
        }
    ];
    const paymentGateways = [
        {
            image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/v2/clm/clm/integrations-stripe.webp"),
            heading: "Stripe",
            desc: "Quick and secure way to accept credit/debit cards online."
        }
    ];
    function Card(param) {
        let { image , heading , desc  } = param;
        return(// <div className=" rounded-2xl border min-h-[350px]  border-2 border-gray-400 p-5 hover:shadow-xl transition-shadow duration-300 cursor-pointer">
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "px-6 py-8 rounded-xl border border-surface-dark bg-surface-light transition-all duration-500 ease-in-out",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    src: image,
                    alt: heading,
                    width: 60,
                    height: 60,
                    className: "mb-12"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "text-4xl font-semibold mb-4 text-gray-800",
                    children: heading
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-gray-800 mt-2 text-lg",
                    children: desc
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Integrations - BoloSign CLM"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Integrate BoloSign CLM with your favorite tools to streamline contract management and boost productivity."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "BoloSign integrations, contract management integrations, CLM integrations, workflow automation, CRM integration, payment gateway integration, sales tools integration"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/clm/integrations/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "bg-gradient-to-tr from-indigo-600 to-purple-500 pb-12",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                            className: " flex flex-col items-center pb-0 text-white max-w-screen-xl mx-auto",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "text-3xl md:text-5xl xl:text-5xl font-semibold md:font-bold mt-10 lg:mt-20 xl:mt-40 text-center xl:w-[70%] md:w-[80%] w-[95%] z-10",
                                    children: "Integrate with BoloSign for 2x faster, AI-powered contract closures"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mt-5 text-center xl:w-[65%] md:w-[75%] w-[95%] px-2 md:text-2xl text-xl mb-10 z-10",
                                    children: "Connect your existing tools to create, track, and sign contracts faster with AI-powered efficiency built in"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: " z-10 mb-5",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_v3_Buttons__WEBPACK_IMPORTED_MODULE_6__/* .CLMButtonSecondaryBorder */ .AL, {
                                        buttonText: "Schedule a demo",
                                        buttonUrl: "/clm/request-demo"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_9__.BASE_ASSETS_URL, "/v2/clm/clm/integrations-hero-bg-transparent.gif"),
                                    alt: "",
                                    width: 500,
                                    height: 500,
                                    className: "w-full h-full object-cover -mt-32 md:-mt-72 xl:-mt-[400px]"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col items-center justify-center max-w-screen-xl mx-auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                            className: "md:pt-32 pt-12 px-8",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "text-4xl md:text-5xl font-semibold mb-16 md:text-center text-start",
                                    children: "Works smoothly with the tools your team already uses"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-4xl font-semibold",
                                    children: "Automation"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "grid md:grid-cols-3 gap-5 my-10 mt-5",
                                    children: automation.map((integration, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, {
                                            image: integration.image,
                                            heading: integration.heading,
                                            desc: integration.desc
                                        }, index))
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-4xl font-semibold mb-3 pt-10",
                                    children: "Sales & CRM"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "grid md:grid-cols-3 gap-5 my-10 mt-5",
                                    children: salesAndCrm.map((integration, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, {
                                            image: integration.image,
                                            heading: integration.heading,
                                            desc: integration.desc
                                        }, index))
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-4xl font-semibold mb-3 pt-10",
                                    children: "Payment Gateways"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "grid md:grid-cols-3 gap-5 my-10 mt-5",
                                    children: paymentGateways.map((integration, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Card, {
                                            image: integration.image,
                                            heading: integration.heading,
                                            desc: integration.desc
                                        }, index))
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-[100%] bg-dark py-16 relative mt-32",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "text-3xl font-semibold mb-3 text-white text-center",
                        children: "Trusted by"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pointer-events-none absolute left-0 top-0 h-full w-24 bg-gradient-to-r from-[#1b1b1b] to-transparent z-10 hidden md:block"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pointer-events-none absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-[#1b1b1b] to-transparent z-10 hidden md:block"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_customers_AnimatedLogos__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Integrations);


/***/ }),

/***/ 97005:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
"use client"


function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

___$insertStyle(".rfm-marquee-container {\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  width: var(--width);\n  transform: var(--transform);\n}\n.rfm-marquee-container:hover div {\n  animation-play-state: var(--pause-on-hover);\n}\n.rfm-marquee-container:active div {\n  animation-play-state: var(--pause-on-click);\n}\n\n.rfm-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.rfm-overlay::before, .rfm-overlay::after {\n  background: linear-gradient(to right, var(--gradient-color), rgba(255, 255, 255, 0));\n  content: \"\";\n  height: 100%;\n  position: absolute;\n  width: var(--gradient-width);\n  z-index: 2;\n  pointer-events: none;\n  touch-action: none;\n}\n.rfm-overlay::after {\n  right: 0;\n  top: 0;\n  transform: rotateZ(180deg);\n}\n.rfm-overlay::before {\n  left: 0;\n  top: 0;\n}\n\n.rfm-marquee {\n  flex: 0 0 auto;\n  min-width: var(--min-width);\n  z-index: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  animation: scroll var(--duration) linear var(--delay) var(--iteration-count);\n  animation-play-state: var(--play);\n  animation-delay: var(--delay);\n  animation-direction: var(--direction);\n}\n@keyframes scroll {\n  0% {\n    transform: translateX(0%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.rfm-initial-child-container {\n  flex: 0 0 auto;\n  display: flex;\n  min-width: auto;\n  flex-direction: row;\n  align-items: center;\n}\n\n.rfm-child {\n  transform: var(--transform);\n}");

const Marquee = React.forwardRef(function Marquee({ style = {}, className = "", autoFill = false, play = true, pauseOnHover = false, pauseOnClick = false, direction = "left", speed = 50, delay = 0, loop = 0, gradient = false, gradientColor = "white", gradientWidth = 200, onFinish, onCycleComplete, onMount, children, }, ref) {
    // React Hooks
    const [containerWidth, setContainerWidth] = React.useState(0);
    const [marqueeWidth, setMarqueeWidth] = React.useState(0);
    const [multiplier, setMultiplier] = React.useState(1);
    const [isMounted, setIsMounted] = React.useState(false);
    const rootRef = React.useRef(null);
    const containerRef = ref || rootRef;
    const marqueeRef = React.useRef(null);
    // Calculate width of container and marquee and set multiplier
    const calculateWidth = React.useCallback(() => {
        if (marqueeRef.current && containerRef.current) {
            const containerRect = containerRef.current.getBoundingClientRect();
            const marqueeRect = marqueeRef.current.getBoundingClientRect();
            let containerWidth = containerRect.width;
            let marqueeWidth = marqueeRect.width;
            // Swap width and height if direction is up or down
            if (direction === "up" || direction === "down") {
                containerWidth = containerRect.height;
                marqueeWidth = marqueeRect.height;
            }
            if (autoFill && containerWidth && marqueeWidth) {
                setMultiplier(marqueeWidth < containerWidth
                    ? Math.ceil(containerWidth / marqueeWidth)
                    : 1);
            }
            else {
                setMultiplier(1);
            }
            setContainerWidth(containerWidth);
            setMarqueeWidth(marqueeWidth);
        }
    }, [autoFill, containerRef, direction]);
    // Calculate width and multiplier on mount and on window resize
    React.useEffect(() => {
        if (!isMounted)
            return;
        calculateWidth();
        if (marqueeRef.current && containerRef.current) {
            const resizeObserver = new ResizeObserver(() => calculateWidth());
            resizeObserver.observe(containerRef.current);
            resizeObserver.observe(marqueeRef.current);
            return () => {
                if (!resizeObserver)
                    return;
                resizeObserver.disconnect();
            };
        }
    }, [calculateWidth, containerRef, isMounted]);
    // Recalculate width when children change
    React.useEffect(() => {
        calculateWidth();
    }, [calculateWidth, children]);
    React.useEffect(() => {
        setIsMounted(true);
    }, []);
    // Runs the onMount callback, if it is a function, when Marquee is mounted.
    React.useEffect(() => {
        if (typeof onMount === "function") {
            onMount();
        }
    }, []);
    // Animation duration
    const duration = React.useMemo(() => {
        if (autoFill) {
            return (marqueeWidth * multiplier) / speed;
        }
        else {
            return marqueeWidth < containerWidth
                ? containerWidth / speed
                : marqueeWidth / speed;
        }
    }, [autoFill, containerWidth, marqueeWidth, multiplier, speed]);
    const containerStyle = React.useMemo(() => (Object.assign(Object.assign({}, style), { ["--pause-on-hover"]: !play || pauseOnHover ? "paused" : "running", ["--pause-on-click"]: !play || (pauseOnHover && !pauseOnClick) || pauseOnClick
            ? "paused"
            : "running", ["--width"]: direction === "up" || direction === "down" ? `100vh` : "100%", ["--transform"]: direction === "up"
            ? "rotate(-90deg)"
            : direction === "down"
                ? "rotate(90deg)"
                : "none" })), [style, play, pauseOnHover, pauseOnClick, direction]);
    const gradientStyle = React.useMemo(() => ({
        ["--gradient-color"]: gradientColor,
        ["--gradient-width"]: typeof gradientWidth === "number"
            ? `${gradientWidth}px`
            : gradientWidth,
    }), [gradientColor, gradientWidth]);
    const marqueeStyle = React.useMemo(() => ({
        ["--play"]: play ? "running" : "paused",
        ["--direction"]: direction === "left" ? "normal" : "reverse",
        ["--duration"]: `${duration}s`,
        ["--delay"]: `${delay}s`,
        ["--iteration-count"]: !!loop ? `${loop}` : "infinite",
        ["--min-width"]: autoFill ? `auto` : "100%",
    }), [play, direction, duration, delay, loop, autoFill]);
    const childStyle = React.useMemo(() => ({
        ["--transform"]: direction === "up"
            ? "rotate(90deg)"
            : direction === "down"
                ? "rotate(-90deg)"
                : "none",
    }), [direction]);
    // Render {multiplier} number of children
    const multiplyChildren = React.useCallback((multiplier) => {
        return [
            ...Array(Number.isFinite(multiplier) && multiplier >= 0 ? multiplier : 0),
        ].map((_, i) => (React__default['default'].createElement(React.Fragment, { key: i }, React.Children.map(children, (child) => {
            return (React__default['default'].createElement("div", { style: childStyle, className: "rfm-child" }, child));
        }))));
    }, [childStyle, children]);
    return !isMounted ? null : (React__default['default'].createElement("div", { ref: containerRef, style: containerStyle, className: "rfm-marquee-container " + className },
        gradient && React__default['default'].createElement("div", { style: gradientStyle, className: "rfm-overlay" }),
        React__default['default'].createElement("div", { className: "rfm-marquee", style: marqueeStyle, onAnimationIteration: onCycleComplete, onAnimationEnd: onFinish },
            React__default['default'].createElement("div", { className: "rfm-initial-child-container", ref: marqueeRef }, React.Children.map(children, (child) => {
                return (React__default['default'].createElement("div", { style: childStyle, className: "rfm-child" }, child));
            })),
            multiplyChildren(multiplier - 1)),
        React__default['default'].createElement("div", { className: "rfm-marquee", style: marqueeStyle }, multiplyChildren(multiplier))));
});

exports.Z = Marquee;
//# sourceMappingURL=index.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5991,9774,2888,179], function() { return __webpack_exec__(43970); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);